import {
    faBook,
    faBullhorn,
    faHeadset,
    faMessageQuestion,
    faPhoneFlip,
} from '@fortawesome/pro-regular-svg-icons';
import { type MaybeRefOrGetter } from 'vue';
import { type IconDefinition } from '@fortawesome/fontawesome-common-types';
import Support from '@components/ui/profile&index/SupportMenu.vue';

const TheSupport = defineAsyncComponent(
    () => import('@components/ui/support/TheSupport.vue')
);

export const useSupport = () => {
    const pageOverlayHandler = usePageOverlay();
    const closeSupport = () => {
        if (!layerId.value) {
            return;
        }
        pageOverlayHandler.closeLayer({ layerId: layerId.value });
        layerId.value = undefined;
    };
    const layerId = ref<string>();
    const openSupport = (args?: {
        sessionId?: number;
        publicKey?: string;
        center?: boolean;
        source?: string;
    }) => {
        if (layerId.value) {
            closeSupport();
        } else {
            layerId.value = pageOverlayHandler.addLayer({
                component: markRaw(TheSupport),
                props: {
                    onClose: closeSupport,
                    ...args,
                },
            });
        }
    };

    const isOpen = computed(() => !!layerId.value);

    return { openSupport, closeSupport, isOpen };
};

export type SupportItem = {
    label: MaybeRefOrGetter<string>;
    icon: IconDefinition;
    click: () => void;
    close?: boolean;
};

export function useSupportList(): SupportItem[] {
    const layoutStore = useLayoutStore();
    const { normalSupportNumber } = classToRefs(layoutStore);
    const { displayTitle, onClick } = useCallNumber({
        displayNumber: () => `021-${normalSupportNumber.value}`,
        clientSide: true,
    });

    const { openSupport } = useSupport();
    const router = useRouter();

    const navigate = (path: string) => () => {
        setTimeout(() => router.push(path), 100);
    };

    return [
        {
            label: 'پشتیبانی آنلاین',
            icon: faHeadset,
            click: () => openSupport({ center: true, source: 'support-menu' }),
            close: true,
        },
        {
            label: displayTitle,
            icon: faPhoneFlip,
            click: onClick,
        },
        {
            label: 'پیشنهادها و شکایات',
            icon: faBullhorn,
            click: navigate('/support/feedback'),
        },
        {
            label: 'پرسش‌های متداول',
            icon: faMessageQuestion,
            click: navigate('/support/faq'),
        },
        {
            label: 'شرایط و مقررات',
            icon: faBook,
            click: navigate('/support/terms-and-conditions'),
        },
    ];
}

export const useSupportMenu = () => {
    const { open: openSupport, close: closeSupport } = usePopOver({
        component: Support,
        attrs: {
            title: 'پشتیبانی',
        },
    });

    return { openSupport, closeSupport };
};
